import { MessageCircle } from "lucide-react";
import { MSG } from "../lib/site";
import { useLead } from "../lib/LeadContext";

const FloatingWhatsApp = () => {
  const { openLead } = useLead();
  return (
    <button
      onClick={() => openLead(MSG.hero)}
      data-testid="floating-whatsapp-button"
      aria-label="Falar no WhatsApp"
      className="animate-pulse-ring fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-lime-350 text-ink-950 shadow-2xl transition-transform duration-300 hover:scale-110 active:scale-95"
    >
      <MessageCircle className="h-6 w-6" fill="currentColor" />
    </button>
  );
};

export default FloatingWhatsApp;
